import { Component } from '@angular/core';

@Component({
  selector: 'app-page-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss']
})
export class ResultsComponent {

}
